import React, { Component } from 'react';
import AdminLoginForm from '../login-form'
import {Redirect} from 'react-router'
import {isAdminLoggedIn} from '../../../../utils/tokenUtils'

import './login.css'

class AdminLogin extends Component {


    render() {
        return ( 
            <div className="row">
                <div className="col-md-5 col-md-offset-1">
                      {isAdminLoggedIn() ? (<Redirect to="/admin/my-profile"/>) : (<AdminLoginForm />)}
                </div>
            </div>
        );
    }
}

export default AdminLogin;



// WEBPACK FOOTER //
// ./src/components/admin/login/login-page/index.jsx